import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { JourneySection } from '../components/JourneySection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-219">
      <Navigation data-id="element-220" />
      <main data-id="element-221">
        <HeroSection data-id="element-222" />
        <JourneySection data-id="element-223" />
        <WelcomeSection data-id="element-224" />
        <OfferingsSection data-id="element-225" />
        <ReviewsSection data-id="element-226" />
        <AboutSection data-id="element-227" />
        <ContactSection data-id="element-228" />
      </main>
      <Footer data-id="element-229" />
    </div>;
}